import { BaseError } from '~/errors/BaseError'

export class StateError extends BaseError {
  constructor(message: string) {
    super(message, 'StateError', new Date().toISOString())
    this.name = this.error
  }
}
